/* District Bangle — stack-add.js
   Adds a prebuilt stack (starter stacks / gift sets) in ONE atomic
   /cart/add.js items[] call, at full price. The advertised saving is the
   merchant's automatic cart discount, applied by Shopify at checkout. */
import { BaseElement, define, afterAdd } from '@theme/global';

class StackAdd extends BaseElement {
  init() {
    this.ids = (this.dataset.ids || '').split(',').map((s) => s.trim()).filter(Boolean);
    this.btn = this.querySelector('[data-stack-add]');
    this.errorEl = this.querySelector('[data-stack-error]');
    if (!this.btn || !this.ids.length) return;
    this.label = this.btn.textContent;
    this.listen(this.btn, 'click', () => this.add());
  }

  async add() {
    this.btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(window.theme.routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: this.ids.map((id) => ({ id, quantity: 1 })) }),
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);
      afterAdd();
      this.btn.classList.add('is-added');
      this.btn.textContent = window.theme.strings.added || '✓ Added';
      setTimeout(() => { this.btn.classList.remove('is-added'); this.btn.textContent = this.label; }, 1800);
      if (this.errorEl) this.errorEl.hidden = true;
    } catch (err) {
      if (this.errorEl) { this.errorEl.textContent = err.message || 'Could not add this stack.'; this.errorEl.hidden = false; }
    } finally {
      this.btn.removeAttribute('aria-busy');
    }
  }
}

define('stack-add', StackAdd);
